var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer_contrast_switcher_block",class:_vm.isContrastMode && 'on',on:{"click":function($event){$event.preventDefault();return (() => _vm.toggleContrastMode()).apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }